import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import IconButton from '@material-ui/core/IconButton'
import ShowIcon from '@material-ui/icons/Visibility'

class ShowButton extends Component {
    handleClick = () => {
        const { basePath, record } = this.props
        this.props.push(`${basePath}/${record.id}/show`)
    }

    render() {
        return (
            <IconButton color="primary" onClick={this.handleClick}>
                <ShowIcon />
            </IconButton>
        )
    }
}

export default connect(null, { push })(ShowButton)
